import { DateTimeFormatter, NSDialogBoxDateTime, NSRouterMakerResult } from "namirasoft-site-react";
import { Component } from 'react';

interface RunDialogBoxProps extends NSRouterMakerResult
{
    reload: () => void;
    set_next_run: (id: string, body: { next_run_at: Date; }) => Promise<void>;
}

interface RunDialogBoxState
{
    id: string | null;
}

class RunDialogBox extends Component<RunDialogBoxProps, RunDialogBoxState>
{
    constructor(props: RunDialogBoxProps)
    {
        super(props);
        this.state = { id: null }
        this.show = this.show.bind(this);
    }
    show(id: string)
    {
        this.setState({ id });
    }
    override render()
    {
        if (!this.state.id)
            return <></>;
        return (
            <NSDialogBoxDateTime
                onClose={() =>
                {
                    this.setState({ id: null });
                }}
                box={{
                    required: true,
                    title: "Schedule Time"
                }}
                button={{
                    title: "Run",
                    onClick: {
                        showLoading: true,
                        action: (onFinished, box) =>
                        {
                            try
                            {
                                let scheduled_at = box?.getValue() ?? new Date();
                                if (!this.state.id)
                                {
                                    onFinished();
                                    return;
                                }
                                this.props.set_next_run(this.state.id, { next_run_at: scheduled_at }).then(() =>
                                {
                                    try
                                    {
                                        let formatted_date_time = new DateTimeFormatter().format(scheduled_at);
                                        this.props.reload();
                                        this.setState({ id: null });
                                        this.props.notifier.onSuccess(`The watch is scheduled to run at ${formatted_date_time}`);
                                    }
                                    catch (error)
                                    {
                                        this.props.notifier.onError(error as Error);
                                    }
                                    finally
                                    {
                                        onFinished();
                                    }
                                }).catch((error) =>
                                {
                                    this.props.notifier.onError(error as Error);
                                    onFinished();
                                });
                            }
                            catch (error)
                            {
                                this.props.notifier.onError(error as Error);
                                onFinished();
                            }
                        }
                    }
                }}
            >
                <></>
            </NSDialogBoxDateTime>
        );
    }
}

export default RunDialogBox;